import { ConfigProvider } from 'antd';
import { configInterceptor } from 'api/api';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import configureAppStore from 'store';
import Home from 'views/Home';
import ResetPassword from 'views/pages/auth/ResetPassword';
import Verify from 'views/pages/verify';

const store = configureAppStore();

configInterceptor(store);

const App = () => {
  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#015A78',
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/auth/verify" element={<Verify type="register" />} />
            <Route path="/auth/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
